<!-- Nav Filter tab start -->
<div class="filter-bar m-b-30">
  <nav class="navbar navbar-light bg-faded">
    <ul class="nav navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" href="javascript:;">
          Comment filter: <span class="sr-only">(current)</span>
        </a>
      </li>
      <li ngbDropdown="" class="nav-item dropdown">
        <a
          ngbDropdownToggle=""
          class="nav-link dropdown-toggle"
          href="javascript:;"
          id="sortBy"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="icofont icofont-filter"></i> Sort By
        </a>
        <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="type">
          <a class="dropdown-item" (click)="changeSortBy('latest')"> Latest </a>
          <a class="dropdown-item" (click)="changeSortBy('trending')">
            Trending
          </a>
          <a class="dropdown-item" (click)="changeSortBy('voted')">
            Most voted
          </a>
        </div>
      </li>

      <li ngbDropdown="" class="nav-item dropdown">
        <a
          ngbDropdownToggle=""
          class="nav-link dropdown-toggle"
          href="javascript:;"
          id="commentCount"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="icofont icofont-listing-number"></i>
          No. of top level comments
        </a>
        <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="type">
          <a class="dropdown-item" (click)="changeCommentCount(2)"> 2 </a>
          <a class="dropdown-item" (click)="changeCommentCount(4)"> 4 </a>
          <a class="dropdown-item" (click)="changeCommentCount(8)"> 8 </a>
        </div>
      </li>
    </ul>

    <div>
      <label class="j-span2 label label-lg label-primary">
        <i class="icofont icofont-filter text-white"></i>
        {{ query.sortBy }}
      </label>
      <label class="j-span2 label label-lg label-primary">
        <i class="icofont icofont-listing-number text-white"></i>
        {{ query.limit }}
      </label>
    </div>
  </nav>
</div>
<!-- Nav Filter tab end -->

<!-- Comment List-->
<div *ngIf="results.length > 0" class="card comment-block">
  <div class="card-header">
    <h5 class="card-header-text">
      <i class="icofont icofont-comment m-r-5"></i> Comments
    </h5>
    <button
      *showAuthed="true"
      type="button"
      class="btn btn-sm btn-primary waves-effect waves-light f-right"
      data-toggle="tooltip"
      title="Add in comments in the box below"
    >
      <i class="icofont icofont-plus"></i>
    </button>
  </div>

  <div class="card-body" [hidden]="loading">
    <parent-comment
      *ngFor="let parentComment of results"
      [comment]="parentComment"
      [currentUser]="currentUser"
      [currentPanelMember]="currentPanelMember"
      [discussion]="discussion"
      (updateAsLoading)="updateAsLoading($event)"
    >
    </parent-comment>
  </div>
</div>

<!-- Comment List-->

<!-- Loader spinner -->
<loader-animation [loading]="loading" [message]="'Loading comments'">
</loader-animation>
<!-- Loader spinner -->

<!-- No content message-->
<no-content-msg
  [hidden]="loading || results.length"
  [message]="'No comments here yet'"
>
</no-content-msg>
<!-- No content message -->

<!-- Pagination -->
<pagination-buttons
  [currentPage]="currentPage"
  [loading]="loading"
  [showNavBar]="true"
  [smallButtons]="false"
  [totalPageCount]="totalPages"
  (setPageTo)="setPageTo($event)"
>
</pagination-buttons>
<!-- Pagination -->
